angular.module('unica_campaign.campaign_controllers', [])

.controller('CampaignBasicController',
	function(
		$rootScope, $scope, $stateParams,
		CampaignTemplateListService, CampaignListService
	) {

	$scope.forms = {};

	$scope.event_id = $stateParams.event_id;

	$scope.campaignTemplateList = [];
	$scope.getCampaignTemplateList = function()
	{
		$rootScope.showLoader();

		CampaignTemplateListService
			.list($scope.event_id)
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.campaignTemplateList = data;

					$scope.$broadcast('campaign_template_list_loaded');
				}
			});
	};

	$scope.campaignData = { };

	$scope.resetCampaignData = function()
	{
		$scope.campaignData = { };
	};

	$scope.getCampaign = function(id)
	{
		$rootScope.showLoader();

		CampaignListService
			.get( id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.campaignData = data;
					$scope.$broadcast('campaign_loaded');
				}
			});
	};

});